module.exports = __webpack_public_path__ + "images/9afc86c.jpg";